module.exports = __webpack_public_path__ + "media/img/img-suggest-ruby-28f16e7f.png";